<script lang="ts">
    export let work: string;
    export let name: string;
    export let bgimg: string;
</script>

<div class="member-image" style="--bgimg: url('{bgimg}')">
    <div class="member-text">
        <span class="work">{work}</span>
        <span class="name">{name}</span>
    </div>
    <div class="overlay" />
</div>

<style lang="scss">
    @import "./src/vars";

    .member-image {
        position: relative;
        aspect-ratio: 2 / 1;
        padding: 1.5em;
        display: flex;
        align-items: flex-end;
        background-image: var(--bgimg);
        background-size: cover;
        background-position: top;
        z-index: 1;

        .infos {
            z-index: 1;
            opacity: 0;
            transition: 0.5s;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            &:hover {
                opacity: 1;
            }
        }

        .member-text {
            position: relative;
            z-index: 1;
            margin: 0;
            text-shadow: 0 0 0.25em rgba(black, 0.3);
            font-size: 1.25rem;
            &,
            & * {
                color: $yellow !important;
            }
            .name,
            .work {
                display: block;
            }
            .name {
                font-weight: 900;
            }
            .work {
                font-weight: 300;
            }
        }
        .overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            background-image: linear-gradient(to top, rgba(black, 0.7), rgba(black, 0) 50%);
            top: 0;
            left: 0;
            z-index: 0;
        }
    }
</style>
